import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from './redux/store';
import { ContextProvider } from './context/context';
import App from './app';
import 'react-toastify/dist/ReactToastify.css';
import 'react-day-picker/dist/style.css';
import './tailwind.build.css';
import './assets/scss/index.scss';

import PageLoading from './components/pageLoading';
import { ReportContextProvider } from './context/report';
import { initI18n } from './configs/i18next';
import I18nProvider from './providers/i18n-provider';

initI18n()
  .then(() => {
    ReactDOM.render(
      <React.StrictMode>
        <Provider store={store}>
          <PersistGate loading={<PageLoading />} persistor={persistor}>
            <I18nProvider>
              <ContextProvider>
                <ReportContextProvider>
                  <App />
                </ReportContextProvider>
              </ContextProvider>
            </I18nProvider>
          </PersistGate>
        </Provider>
      </React.StrictMode>,
      document.getElementById('root'),
    );
  })
  .catch((err) => {
    console.error('i18n init failed', err);
    document.getElementById('root').innerHTML =
      '<p style="font-family:sans-serif;padding:16px">Failed to load translations. Please refresh.</p>';
  });
